import { SavedCartEffects } from './saved-cart.effect';

export const effects: any[] = [SavedCartEffects];

export * from './saved-cart.effect';
